module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Schoeftland-147002f0b3d29f7cdf4767d6086267ff.svg";